// @core/stores/booking/BookingStatStore.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { makeAutoObservable, runInAction } from 'mobx';
import { bookingApi } from '@core/api';
import type {
  ResourceStatsResponse,
} from '@core/types/booking';

class BookingStatStore {

  // Loading states
  isLoading = false;

  // Error state (stores full ApiClientError for request context)
  error: unknown = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Actions
  setError(error: unknown): void {
    this.error = error;
  }

  clearError(): void {
    this.error = null;
  }

  reset(): void {
    this.error = null;
  }

  /**
   * Get resource stats
   */
  async GetResourceStats(resource_id: string, params?: { period_from?: string | number | boolean; period_to?: string | number | boolean; }): Promise<ResourceStatsResponse> {
    this.isLoading = true;
    this.error = null;

    try {
      const result = await bookingApi.GetResourceStats(resource_id, params);

      runInAction(() => {
        this.isLoading = false;
      });

      return result;
    } catch (error) {
      runInAction(() => {
        this.error = error;
        this.isLoading = false;
      });
      throw error;
    }
  }
}

export const bookingStatStore = new BookingStatStore();
